import React from "react";
import styled from "styled-components";
import InnerPageLayout from "../../Components/Layout/InnerPageLayout";
import News from "../../Components/news";

interface IProps {
}
const NewsListPage = (props: IProps) => {
  return (
    <InnerPageLayout>
      <Container>
        <News limit={100} />
      </Container>
    </InnerPageLayout>
  );
};
const Container = styled.div``;
export default NewsListPage;
